import { FormattedMessage } from 'react-intl';
import React from 'react';

export const transactionsColumns = {
  state: {
    id: 'state',
    label: <FormattedMessage id={'app.transactions.state'} />,
    align: 'left',
    options: {
      sortable: true,
      filterable: true,
    },
    width: '90px',
  },
  transactionId: {
    id: 'transactionId',
    label: <FormattedMessage id={'app.transactions.id'} />,
    align: 'left',
    width: '50px',
  },
  createdAt: {
    id: 'createdAt',
    label: <FormattedMessage id={'app.transactions.createdAt'} />,
    align: 'left',
    options: {
      sortable: true,
      canSelectDateRange: true,
    },
    width: '115px',
  },
  contractId: {
    id: 'idExternal',
    label: <FormattedMessage id={'app.transactions.contractId'} />,
    align: 'left',
    width: '120px',
  },
  organizationName: {
    id: 'organizationName',
    label: <FormattedMessage id={'app.transactions.organization'} />,
    align: 'left',
    options: {
      sortable: true,
      filterable: true,
    },
    width: '200px',
  },
  commodity: {
    id: 'commodity',
    label: <FormattedMessage id={'app.transactions.commodity'} />,
    align: 'left',
    width: '70px',
    options: {
      filterable: true,
    },
  },
  requestPeriod: {
    id: 'period',
    label: <FormattedMessage id={'app.transactions.requestPeriod'} />,
    align: 'left',
    options: {
      sortable: true,
      filterable: true,
    },
    width: '145px',
  },
  exchangeProductName: {
    id: 'exchangeProductName',
    label: <FormattedMessage id={'app.transactions.product'} />,
    align: 'left',
    options: {
      filterable: true,
      sortable: true,
    },
    width: '140px',
  },
  isSale: {
    id: 'isSale',
    label: <FormattedMessage id={'app.transactions.isSale'} />,
    align: 'left',
    width: '140px',
  },
  transactionType: {
    id: 'transactionType',
    label: <FormattedMessage id={'app.transactions.isSale'} />,
    align: 'left',
    options: {
      filterable: true,
      sortable: true,
    },
    width: '180px',
  },
  purchaseType: {
    id: 'purchaseType',
    label: <FormattedMessage id={'app.transactions.purchaseType'} />,
    align: 'left',
    width: '120px',
    options: {
      filterable: true,
    },
  },
  priceSource: {
    id: 'priceSource',
    label: <FormattedMessage id={'app.transactions.priceSource'} />,
    align: 'left',
    width: '80px',
    options: {
      filterable: true,
    },
  },
  currency: {
    id: 'currency',
    label: <FormattedMessage id={'app.transactions.currency'} />,
    align: 'left',
    options: {
      filterable: true,
    },
    width: '40px',
  },
  quantity: {
    id: 'quantity',
    label: <FormattedMessage id={'app.transactions.quantity'} />,
    align: 'right',
    options: {
      sortable: true,
    },
    width: '60px',
  },
  rate: {
    id: 'rate',
    label: <FormattedMessage id={'app.transactions.rate'} />,
    align: 'right',
    width: '60px',
  },
  price: {
    id: 'price',
    label: <FormattedMessage id={'app.transactions.price'} />,
    align: 'right',
    options: {
      sortable: true,
    },
    width: '160px',
  },
};
